/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-13 16:19:11
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-30 17:17:26
 */
import { defineStore } from 'pinia'
import { LoginCheck, LoginRes } from '@/service/model'
import { AjaxAuthService } from '@/service/api'

const setBonreeUserId = (userInfo: LoginRes) => {
  try {
    userInfo?.id && window.bonreeRUM && window.bonreeRUM.setUserID(userInfo.id);
  } catch (error) {
    console.error('bonreeRUM setUserID error:', error);
  }
};

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    userInfo: {} as LoginRes,
    /* userLevel   说明
    * ADMIN(0, "超管"),
      HEADQUARTERS(1, "总部"),
      REGION(2, "区域"),
      FRANCHISEE(3,"代理商");
    * */
    userLevel: '',
    isLoggedIn: false,
    menuList: [],
    getMenuLoading: false,
    tabList: [],
    buttonList: [] as string[]
  }),
  getters: {
    getMenusList: (state) => state.menuList,
    getUserLevel: (state) => state.userLevel,
    getAgencyId: (state) => state.userInfo.agencyId || ''
  },
  actions: {
    /**
     * @description: 设备验证
     * @param {LoginCheck} params
     * @return {*}
     */
    checkNewDevice(params: LoginCheck | undefined): Promise<any> {
      return new Promise((resolve, reject) => {
        AjaxAuthService.checkNewDevice(params)
          .then((res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.authToken
              this.userLevel = res.data.userType?.id
              this.isLoggedIn = true
              setBonreeUserId(this.userInfo)
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        AjaxAuthService.login(params)
          .then((res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.authToken
              this.userLevel = res.data.userType?.id
              this.isLoggedIn = true
              setBonreeUserId(this.userInfo)
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        AjaxAuthService.logOut()
          .then((res) => {
            if (res.code === 1) {
              this.token = ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    // 获取登录人菜单权限
    getUsernMenu() {
      return new Promise((resolve, reject) => {
        this.getMenuLoading = true
        AjaxAuthService.getMenuList()
          .then((res) => {
            if (res.code === 1) {
              console.log(res.data, 111)
              this.menuList = res.data
            }
            resolve(res)
          })
          .catch((err) => reject(err))
          .finally(() => {
            this.getMenuLoading = false
          })
      })
    },
    // 获取buttonList和tabList权限
    getTabOrButtonList() {
      return new Promise((resolve, reject) => {
        AjaxAuthService.getTabOrButtonList()
          .then((res) => {
            if (res.code === 1) {
              this.buttonList = res.data.buttonList
              this.tabList = res.data.tabList
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
